<template>
	<div class="tab" data-name="languageInfo" data-type="table">
		<h3>فرم تسلط به زبانهای خارجی</h3>
		<p>[ این فرم مربوط به میزان تسلط شما بر دیگر زبان هامی باشد، لطفا میزان تسلط خود را با مقادیر خیلی خوب، خوب، متوسط و یا ضعیف مشخص نمایید]</p>
		<table class="table table-bordered">
			<thead>
				<tr>
					<td>نام زبان</td>
					<td>درک مطلب</td>
					<td>مکالمه</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<input type="text" class="form-control" disabled data-name="name" value="انگلیسی" id="english">
					</td>
					<td>
						<input type="text" class="form-control" data-name="Comprehension" />
					</td>
					<td>
						<input type="text" class="form-control" data-name="conversation" />
					</td>
				</tr>
				<tr>
					<td>
						<input type="text" class="form-control" disabled data-name="name" value="فرانسه" id="endlish">
					</td>
					<td>
						<input type="text" class="form-control" data-name="Comprehension" />
					</td>
					<td>
						<input type="text" class="form-control" data-name="conversation" />
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		emits: ["change"],
		props: {
			init: {
				type: Function,
			},
			contract: {
				type: Object,
			},
		},

		change(e)
		{
			this.$emit("change", e.target);
		},

		mounted()
		{
			this.init();
		}
	};
</script>
<style scoped>
	.form-control:disabled {
		background-color: unset;
	}
</style>
